<template>
  <v-form ref="form" class="">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-alert
      type="info"
      elevation="2"
      v-if="partialReadOnly"
      dismissible
      class="mt-2"
    >
      Esta conta a pagar já possui parcelas pagas, por isso você pode editar somente o plano de contas e os ciclos vinculados. 
      Caso queira editar a conta, você deve cancelar o pagamento de todas as parcelas pagas dessa conta.
    </v-alert>

    <v-tabs>
      <v-tab>Geral</v-tab>
      <v-tab>Ciclos Vinculados</v-tab>

      <v-tab-item>
        <v-row>
          <!-- <v-col cols="3">
            <MaskedTextField
              v-bind="getObject('code')"
              :inputData.sync="entry.code"
              mask-type="integer"
              label="Código"
              readonly
              :disabled="readOnly"
            />
          </v-col> -->

          <v-col cols="12" sm="3">
            <DateField
              :inputData.sync="entry.billDate"
              v-bind="getObject('billDate')"
              label="Data de Faturamento"
              :hasTodayButton="true"
              :hasTodayDate="entry.billDate ? false : true"
              :disabled="partialReadOnly || readOnly"
              autocomplete="off"
            />
          </v-col>

          <v-col cols="12" sm="9">
            <v-autocomplete
              v-model="entry.supplierId"
              v-bind="getObject('supplierId')"
              label="Pagar para a Pessoa"
              :items="extraData.accountContext.allPeople"
              item-value="id"
              item-text="name"
              @input="selectSupplier"
              :disabled="partialReadOnly || readOnly"
              autocomplete="off"
            >
              <template v-slot:append-outer>
                <PersonNew
                  :inlineAddButton="true"
                  :isSupplier="true"
                  @entry-created="personCreated"
                  modelNameSingular="Pessoa"
                />
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="9">
            <v-text-field
              v-model="selectedChartOfAccountName"
              v-bind="getObject('chartId')"
              label="Plano de Contas"
              @click="clickChartOfAccount"
              ref="textFieldChartOfAccountRef"
              :class="'enabledTextFieldChartOfAccount'"
              autocomplete="off"
              inputmode="none"
              :disabled="readOnly"
            />
          </v-col>

          <ChartOfAccountSelect
            newTitle="Selecionar Plano de Contas"
            width="50%"
            newSaveButtonLabel="Confirmar"
            @select-confirm-action="chartOfAccountSelected"
            ref="chartOfAccountSelectRef"
            :loadActiveChartOfAccount="entry.chart"
            :subtreesOfCodes="['4']"
          />

          <!-- <v-col cols="3">
            <v-btn
              color="primary"
              class="ma-1"
              @click="showAddPeriods = !showAddPeriods">
                {{!showAddPeriods ? "Vincular Ciclos" : "Esconder Ciclos"}}
              <v-icon right v-if="!showAddPeriods">mdi-plus</v-icon>
            </v-btn>
          </v-col> -->
        </v-row>

        <!-- <v-col cols="4">
          <MaskedTextField
            v-bind="getObject('totalPrice')"
            :inputData.sync="entry.totalPrice"
            mask-type="currency"
            label="Valor Total"
            prefix="R$"
            persistent-hint
            :disabled="readOnly"
          />
        </v-col> -->

        <v-row>
          <v-col cols="12" class="">
            <PaymentIndex
              :payments="entry.paymentsAttributes"
              :readOnly="partialReadOnly || readOnly"
              modelType="CashOutflow"
              :totalPayment.sync="totalPayment"
              @installment-update="$emit('installment-update', $event)"
              :hasTableTitle="true"
              tableTitle="Pagamentos"
              :extraData="extraData.extraData2"
            />
          </v-col>

        </v-row>

        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="entry.observation"
              v-bind="getObject('observation')"
              label="Observações"
              outlined
              :disabled="readOnly"
              autocomplete="off"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item>
        <v-row>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="harvestId"
              label="Filtrar Ciclos por Safra"
              :items="extraData.accountContext.allHarvests"
              item-value="id"
              item-text="name"
              @change="loadCulturesFromHarvest"
              clearable
              @click:clear="harvestId = null; cultureList = []; cultureId = null"
              autocomplete="off"
              :disabled="readOnly"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="cultureId"
              label="Filtrar Ciclos por Cultura"
              :items="cultureList"
              item-value="id"
              item-text="name"
              @change="loadPeriodsFromHarvestAndCulture"
              :disabled="!harvestId || readOnly"
              clearable
              @click:clear="cultureId = null"
              autocomplete="off"
            />
          </v-col>

          <v-col cols="12" md="6" >
            <v-autocomplete
              v-model="periodStatuses"
              label="Status dos Ciclos"
              :items="extraData.globalContext.allPeriodStatuses"
              item-value="value"
              item-text="text"
              clearable
              @click:clear="periodStatuses = []"
              multiple
              chips
              dense
              deletable-chips
              hint="Se nenhum status for selecionado, todos serão exibidos"
              persistent-hint
              @change="loadPeriodsFromHarvestAndCulture"
            />
          </v-col>

          <v-col cols="12" class="">
            <MultiSelect
              v-model="entry.periodIds"
              v-bind="getObject('periodIds')"
              label="Ciclo(s)"
              :items="extraData.accountContext.allPeriodsEnabledForCostApportionment"
              :loadingItems="loadingPeriodsList"
              itemSubText="additionalInfo"
              itemSecondSubText="secondAdditionalInfo"
              :readOnly="readOnly"              
            >
              <template v-slot:new_action>
                <PeriodNew
                  :inlineAddButton="true"
                  @entry-created="periodCreated"
                  modelNameSingular="Ciclo"
                />
              </template>
            </MultiSelect>
          </v-col>

        </v-row>
      </v-tab-item>
    </v-tabs>
  </v-form>
</template>

<script>
import MultiSelect from "@shared_components/multi_select.vue";
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue"
import PaymentIndex from "@models/payments/index.vue"
import ChartOfAccountSelect from "@models/chart_of_accounts/select.vue"
import gql from 'graphql-tag';
import PersonNew from "@models/people/new.vue"
import BaseUtil from "@shared_components/base_util.vue"
import PeriodNew from "@models/periods/new.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      totalPayment: 0,
      selectedChartOfAccountName: null,
      harvestId: null,
      cultureList: [],
      cultureListLoading: false,
      periodStatuses: [],
      cultureId: null,
      loadingPeriodsList: false,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    partialReadOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MultiSelect: MultiSelect,
    MaskedTextField: MaskedTextField,
    DateField: DateField,
    PaymentIndex: PaymentIndex,
    ChartOfAccountSelect: ChartOfAccountSelect,
    PersonNew: PersonNew,
    BaseUtil: BaseUtil,
    PeriodNew: PeriodNew
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);

    for (var payment in this.entry.paymentsAttributes) {
      if (this.entry.paymentsAttributes[payment] && this.entry.paymentsAttributes[payment].value && !this.entry.paymentsAttributes[payment]._destroy) {
        this.totalPayment += this.entry.paymentsAttributes[payment].value;
      }
    }
    this.totalPayment = _.round(this.totalPayment, 2);

    if (this.entry.chart) {
      this.selectedChartOfAccountName = this.entry.chart.text;
    }

    if (this.periodStatuses.length == 0 && this.extraData.globalContext.allPeriodStatuses.length > 0) {
      this.periodStatuses = [1];
    }
    if(this.entry.supplierId){
      this.selectSupplier();
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    clickChartOfAccount: function() {
      this.$refs.chartOfAccountSelectRef.openDialog();
      this.$refs.textFieldChartOfAccountRef.blur();
    },
    chartOfAccountSelected: function(val) {
      // console.log(val);
      this.entry.chart = val;
      this.entry.chartId = val.id;
      this.selectedChartOfAccountName = val.text;
    },
    //metodo para resetar o chart se precisar (ainda nao utilizado)
    resetCharts: function(){
      this.entry.chart = null;
      this.entry.chartId = null;
      this.selectedChartOfAccountName = "";
    },
    loadCulturesFromHarvest: function() {
      if (this.harvestId){
        this.cultureListLoading = true;
        this.$apollo
          .query({
            query: CULTURES_FROM_HARVEST_QUERY,
            variables: {
              harvestId: this.harvestId
            },
            fetchPolicy: "no-cache"
          })
          .then(response => {
            this.cultureList = response.data.accountContext.allCulturesFromHarvest;
            // console.log("this.cultureList", this.cultureList);
          })
          .catch(response => console.log(response))
          .finally(() => (this.cultureListLoading = false));
      }
      this.loadPeriodsFromHarvestAndCulture();
    },   
    loadPeriodsFromHarvestAndCulture: function() {
      this.loadingPeriodsList = true;
      this.$apollo
        .query({
          query: PERIODS_FROM_HARVEST_AND_CULTURES_QUERY,
          variables: {
            harvestId: this.harvestId,
            cultureId: this.cultureId,
            periodStatuses: this.periodStatuses,
            cashFlowId: this.entry.id
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {         
          this.extraData.accountContext.allPeriodsEnabledForCostApportionment = response.data.accountContext.allPeriodsEnabledForCostApportionment;
          // console.log("periods for cos apportionment", this.extraData.accountContext.allPeriodsEnabledForCostApportionment);
          // this.multiSelectKey+=1;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loadingPeriodsList = false));
    },
    personCreated: function(person) {
      //testar pra ver se o tipo é supplier
      // if (person.isSupplier) {
      this.extraData.accountContext.allPeople.unshift(person);
      this.entry.supplierId = person.id;
      this.entry.supplier = person;
      // } else {
      //   this.$refs.util.showErrorMessage("A pessoa cadastrada não é do tipo Fornecedor, por isso não irá aparecer na lista de fornecedores!");
      // }
    },
    periodCreated: function(period) {
      this.extraData.accountContext.allPeriodsEnabledForCostApportionment.unshift(period);
      this.entry.periodIds.push(period.id);
    },
    selectSupplier: function(){
      // this.loadingPeriodsList = true;
      this.$apollo
        .query({
          query: LAST_CASH_OUTFLOW_QUERY,
          variables: {
            personId: this.entry.supplierId            
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // console.log("teste", response.data.accountContext.lastCashOutflowForPerson.id);
          if(response.data.accountContext.lastCashOutflowForPerson){
            // console.log("aqui", this.entry.chartId);
            if(this.entry.chartId){
            }else{
              // console.log("caiu aqui");
              // this.entry.chartId = response.data.accountContext.lastCashOutflowForPerson.id
              // this.entry.chart = this.extraData.accountContext.allPeople.find(obj => obj.id == this.entry.supplierId);

              this.chartOfAccountSelected(response.data.accountContext.lastCashOutflowForPerson);
              // this.entry.chart = this.extraData.accountContext.allPeople.find(obj => obj.id == this.entry.supplierId);

            }
          }         
          // this.entry = response.data.accountContext.allPeriodsEnabledForCostApportionment;
          // console.log("periods for cos apportionment", this.extraData.accountContext.allPeriodsEnabledForCostApportionment);
          // this.multiSelectKey+=1;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loadingPeriodsList = false));
    },
  }
};

const CULTURES_FROM_HARVEST_QUERY = gql `
  query ($harvestId: ID!) {
    accountContext {
      allCulturesFromHarvest(harvestId: $harvestId){
        id
        name
      }
    }
  }
`;

const LAST_CASH_OUTFLOW_QUERY = gql `
  query ($personId: ID!) {
    accountContext {
      lastCashOutflowForPerson(personId: $personId){
        id
        name
        code
        text
      }
    }
  }
`;

const PERIODS_FROM_HARVEST_AND_CULTURES_QUERY = gql `
  query ($harvestId: ID, $cultureId: ID, $periodStatuses: [ID!], $cashFlowId: ID) {
    accountContext {
      allPeriodsEnabledForCostApportionment(harvestId: $harvestId, cultureId: $cultureId, periodStatuses: $periodStatuses, cashFlowId: $cashFlowId){
        id
        name
        additionalInfo
        secondAdditionalInfo
      }
    }
  }
`;

</script>

<style scoped>
  ::v-deep .enabledTextFieldChartOfAccount input {
    cursor: pointer;
  }
</style>
